import React, { useEffect, useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { apiFetchJson } from "../../../utils/http";

export default function VerProductosTarjeta({
  registro = {}, // viene desde la fila seleccionada (contiene id)
  onClose = () => {},
}) {
  const [detalle, setDetalle] = useState(null);
  const [cargando, setCargando] = useState(true);

  const safe = (v, fb = "—") =>
    v === null || v === undefined || String(v).trim() === "" ? fb : v;

  const getAuthToken = () =>
    localStorage.getItem("access_token") ||
    localStorage.getItem("token") ||
    sessionStorage.getItem("access_token") ||
    sessionStorage.getItem("token") ||
    "";

  useEffect(() => {
    let mounted = true;
    const fetchDetalle = async () => {
      try {
        if (!registro?.id) {
          setDetalle(registro);
          return;
        }
        const url = apiRoutes.productoTarjeta.detail(registro.id);
        const token = getAuthToken();
        const data = await apiFetchJson(url, {
          headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        });
        if (mounted) setDetalle(data || registro);
      } catch (e) {
        console.error("Error al cargar detalle producto-tarjeta:", e);
        if (mounted) setDetalle(registro);
      } finally {
        if (mounted) setCargando(false);
      }
    };
    fetchDetalle();
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [registro?.id]);

  const productoCodigo =
    detalle?.productoCodigo ?? registro?.productoCodigo ?? "";
  const productoNombre =
    detalle?.productoNombre ?? registro?.productoNombre ?? "";
  const nroTarjeta =
    detalle?.tarjetaNumero ??
    registro?.tarjetaNumero ??
    registro?.numeroTarjeta ??
    "";

  const filas = [
    [
      "Producto",
      safe(`${productoCodigo ? productoCodigo + " - " : ""}${productoNombre}`),
    ],
    ["Código de Producto", safe(productoCodigo)],
    ["Descripción", safe(productoNombre)],
    ["Nro. de Tarjeta", safe(nroTarjeta)],
  ];

  return (
    <div className="w-full">
      {/* Header */}
      <div className="px-6 py-4 border-b">
        <h2 className="section-title">Datos de Productos Tarjeta</h2>
      </div>

      {/* Body */}
      <div className="px-6 py-6">
        {cargando ? (
          <div className="text-sm text-gray-500">Cargando…</div>
        ) : (
          <div className="grid grid-cols-1 gap-y-3">
            {filas.map(([label, value]) => (
              <Fila key={label} label={label} value={value} />
            ))}
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="modal-footer">
        <div className="flex justify-end">
          <button onClick={onClose} className="btn-fil">
            Nueva consulta
          </button>
        </div>
      </div>
    </div>
  );
}

function Fila({ label, value }) {
  return (
    <div className="grid grid-cols-[180px_1fr] gap-y-2">
      <div className="label">{label}:</div>
      <div className="value">{value}</div>
    </div>
  );
}
